(() => {
  const doc = document;
  const body = doc.body;
  const qs = (selector, scope = doc) => scope.querySelector(selector);
  const qsa = (selector, scope = doc) => [...scope.querySelectorAll(selector)];
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };
  const toast = (message) => {
    const node = qs('[data-toast]');
    if (!node) return;
    node.textContent = message;
    node.classList.add('is-visible');
    clearTimeout(node._timer);
    node._timer = setTimeout(() => node.classList.remove('is-visible'), 2600);
  };

  const closeDrawers = () => {
    qsa('.drawer.is-open').forEach((drawer) => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); });
    body.classList.remove('drawer-open');
  };
  const openDrawer = (drawer) => {
    if (!drawer) return;
    closeDrawers();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('drawer-open');
    setTimeout(() => qs('input,button,a', drawer)?.focus(), 350);
  };
  doc.addEventListener('click', (event) => {
    if (event.target.closest('[data-search-open]')) openDrawer(qs('[data-search-drawer]'));
    if (event.target.closest('[data-cart-open]')) openDrawer(qs('[data-cart-drawer]'));
    if (event.target.closest('[data-drawer-close]')) closeDrawers();
  });
  doc.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawers(); });

  const menuButton = qs('[data-menu-toggle]');
  const mobileMenu = qs('[data-mobile-menu]');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    mobileMenu.hidden = open;
    body.classList.toggle('menu-open', !open);
  });

  qs('[data-hero-mode]')?.addEventListener('click', (event) => {
    event.currentTarget.closest('.hero-gallery')?.classList.toggle('is-turned');
  });

  qsa('[data-zodiac-gallery]').forEach((gallery) => {
    const luopan = qs('[data-luopan]', gallery);
    const wheel = qs('[data-luopan-wheel]', gallery);
    const items = qsa('[data-luopan-item]', gallery);
    if (!luopan || !wheel || !items.length) return;
    let rotation = 0;
    let activeIndex = 0;
    let dragging = false;
    let lastPointerAngle = 0;

    const normalizeIndex = (index) => ((index % items.length) + items.length) % items.length;
    const pointerAngle = (event) => {
      const rect = luopan.getBoundingClientRect();
      const x = event.clientX - (rect.left + rect.width / 2);
      const y = event.clientY - (rect.top + rect.height / 2);
      return Math.atan2(y, x) * 180 / Math.PI;
    };
    const selectIndex = (index) => {
      activeIndex = normalizeIndex(index);
      const activeItem = items[activeIndex];
      const id = activeItem.dataset.luopanItem;
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
      qsa('[data-zodiac-panel]', gallery).forEach((panel) => panel.classList.toggle('is-active', panel.dataset.zodiacPanel === id));
      qsa('[data-zodiac-readout]', gallery).forEach((readout) => readout.classList.toggle('is-active', readout.dataset.zodiacReadout === id));
      luopan.setAttribute('aria-valuenow', String(activeIndex + 1));
      luopan.setAttribute('aria-valuetext', activeItem.dataset.signName || String(activeIndex + 1));
    };
    const drawRotation = () => wheel.style.setProperty('--luopan-angle', `${rotation}deg`);
    const snapToIndex = (index) => {
      const normalized = normalizeIndex(index);
      const baseTarget = -normalized * (360 / items.length);
      rotation = baseTarget + 360 * Math.round((rotation - baseTarget) / 360);
      luopan.classList.add('is-snapping');
      drawRotation();
      selectIndex(normalized);
      window.setTimeout(() => luopan.classList.remove('is-snapping'), 700);
    };

    luopan.addEventListener('pointerdown', (event) => {
      if (event.button !== undefined && event.button !== 0) return;
      dragging = true;
      lastPointerAngle = pointerAngle(event);
      luopan.classList.add('is-dragging');
      luopan.setPointerCapture?.(event.pointerId);
      event.preventDefault();
    });
    luopan.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const nextAngle = pointerAngle(event);
      let delta = nextAngle - lastPointerAngle;
      if (delta > 180) delta -= 360;
      if (delta < -180) delta += 360;
      rotation += delta;
      lastPointerAngle = nextAngle;
      drawRotation();
      selectIndex(Math.round(-rotation / (360 / items.length)));
      event.preventDefault();
    });
    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      luopan.classList.remove('is-dragging');
      luopan.releasePointerCapture?.(event.pointerId);
      const step = Math.round(-rotation / (360 / items.length));
      snapToIndex(step);
    };
    luopan.addEventListener('pointerup', endDrag);
    luopan.addEventListener('pointercancel', endDrag);
    luopan.addEventListener('keydown', (event) => {
      let nextIndex = activeIndex;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex += 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex -= 1;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = items.length - 1;
      else return;
      event.preventDefault();
      snapToIndex(nextIndex);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const target = event.target.closest?.('[data-luopan-item], [data-zodiac-panel]');
      if (!target || !gallery.contains(target)) return;
      const id = target.dataset.luopanItem || target.dataset.zodiacPanel;
      const index = items.findIndex((item) => item.dataset.luopanItem === id);
      if (index >= 0) snapToIndex(index);
    });
    selectIndex(0);
  });

  qsa('quantity-input').forEach((root) => {
    const input = qs('input', root);
    qs('[data-quantity-minus]', root)?.addEventListener('click', () => { input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    qs('[data-quantity-plus]', root)?.addEventListener('click', () => { input.value = Number(input.value || 1) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  const showMedia = (root, mediaId) => {
    qsa('[data-media-id]', root).forEach((node) => node.classList.toggle('is-active', String(node.dataset.mediaId) === String(mediaId)));
    qsa('[data-media-target]', root).forEach((node) => node.classList.toggle('is-active', String(node.dataset.mediaTarget) === String(mediaId)));
  };
  qsa('[data-product-gallery]').forEach((gallery) => {
    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) showMedia(gallery, thumb.dataset.mediaTarget);
    });
  });

  qsa('[data-media-open]').forEach((button) => button.addEventListener('click', () => {
    const dialog = qs(`[data-media-dialog="${button.dataset.mediaOpen}"]`);
    if (!dialog) return;
    if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
  }));
  qsa('[data-media-dialog]').forEach((dialog) => {
    qs('[data-lightbox-close]', dialog)?.addEventListener('click', () => dialog.close ? dialog.close() : dialog.removeAttribute('open'));
    qs('[data-lightbox-zoom]', dialog)?.addEventListener('click', () => qs('[data-lightbox-canvas]', dialog)?.classList.toggle('is-zoomed'));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  });

  qsa('[data-product-root]').forEach((root) => {
    const dataNode = qs('[data-product-json]', root);
    if (!dataNode) return;
    let variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch (_) { return; }
    const form = qs('[data-product-form]', root);
    const picker = qs('[data-variant-picker]', root);
    if (!form || !picker) return;
    const optionGroups = qsa('[data-option-index]', picker);
    const chooseVariant = () => {
      const selectedOptions = optionGroups.map((group) => qs('input:checked', group)?.value);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selectedOptions[index]));
      if (!variant) return;
      qs('[data-variant-id]', form).value = variant.id;
      const price = qs('[data-product-price]', form);
      if (price) price.innerHTML = `<span>${money(variant.price)}</span>${variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : ''}`;
      const add = qs('[data-add-to-cart]', form);
      if (add) { add.disabled = !variant.available; qs('[data-add-label]', add).textContent = variant.available ? 'Add to cabinet' : 'Unavailable'; }
      optionGroups.forEach((group) => { const selected = qs('input:checked', group); const label = qs('[data-option-value]', group); if (label && selected) label.textContent = selected.value; });
      if (variant.featured_media?.id) showMedia(qs('[data-product-gallery]', root), variant.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      optionGroups.forEach((group, groupIndex) => {
        qsa('input', group).forEach((input) => {
          const test = [...selectedOptions]; test[groupIndex] = input.value;
          input.disabled = !variants.some((candidate) => candidate.available && candidate.options.every((option, index) => option === test[index] || index !== groupIndex));
        });
      });
    };
    picker.addEventListener('change', chooseVariant);
  });

  const zodiacSigns = [
    ['aries', 'Aries object'], ['taurus', 'Taurus object'], ['gemini', 'Gemini object'],
    ['cancer', 'Cancer object'], ['leo', 'Leo object'], ['virgo', 'Virgo object'],
    ['libra', 'Libra object'], ['scorpio', 'Scorpio object'], ['sagittarius', 'Sagittarius object'],
    ['capricorn', 'Capricorn object'], ['aquarius', 'Aquarius object'], ['pisces', 'Pisces object']
  ];
  const zodiacFor = (item) => {
    const signature = `${item.handle || ''} ${item.product_title || ''} ${item.variant_title || ''}`.toLowerCase();
    return zodiacSigns.find(([name]) => signature.includes(name)) || ['celestial', 'Celestial object'];
  };
  const cartImageURL = (url, width = 320) => `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
  const cartHTML = (cart) => {
    if (!cart.items.length) return '<div class="zodiac-cart-empty"><span>✦</span><h3>Your orbit is open.</h3><p>Choose an object whose character belongs in your space.</p><a class="button button-light" href="/collections/all">Enter the zodiac rooms →</a></div>';
    const items = cart.items.map((item, index) => {
      const [sign, label] = zodiacFor(item); const symbol = document.querySelector(".zodiac-glyph--" + sign)?.outerHTML || "â¦";
      const image = item.featured_image?.url ? `<img src="${escapeHTML(cartImageURL(item.featured_image.url))}" width="150" height="150" alt="${escapeHTML(item.product_title)}">` : '';
      return `<article class="zodiac-cart-item">
        <a class="zodiac-cart-image" href="${escapeHTML(item.url)}">${image}<span>${symbol}</span></a>
        <div class="zodiac-cart-item-copy">
          <small>${label} · ${String(index + 1).padStart(2, '0')}</small>
          <h3><a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a></h3>
          ${item.variant_title ? `<p>${escapeHTML(item.variant_title)}</p>` : ''}
          <footer>
            <div class="zodiac-cart-quantity" aria-label="Quantity">
              <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <strong>${money(item.final_line_price)}</strong>
            <button class="zodiac-cart-remove" type="button" data-cart-change data-line="${index + 1}" data-quantity="0">Remove</button>
          </footer>
        </div>
      </article>`;
    }).join('');
    const drawer = qs('[data-cart-drawer]');
    const processing = escapeHTML(drawer?.dataset.processing || '1–3 business days');
    const delivery = escapeHTML(drawer?.dataset.delivery || '4–8 business days');
    return `<div class="zodiac-cart-items">${items}</div>
      <div class="zodiac-cart-service"><span><small>01 · Processing</small><b>${processing}</b></span><span><small>02 · Estimated arrival</small><b>${delivery}</b></span></div>
      <div class="zodiac-cart-total"><span>Cabinet subtotal</span><strong>${money(cart.total_price)}</strong></div>
      <a class="button zodiac-checkout" href="/checkout">Proceed to checkout →</a>
      <a class="zodiac-view-cart" href="/cart">Review full cabinet</a>`;
  };
  const refreshCart = async (shouldOpen = false) => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    qsa('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const content = qs('[data-cart-drawer-content]');
    if (content) content.innerHTML = cartHTML(cart);
    if (shouldOpen) openDrawer(qs('[data-cart-drawer]'));
  };
  doc.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-cart-change]');
    if (!control) return;
    control.disabled = true;
    control.closest('.zodiac-cart-item')?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(control.dataset.line), quantity: Number(control.dataset.quantity) })
      });
      if (!response.ok) throw new Error('Unable to update this object.');
      await refreshCart(false);
    } catch (error) {
      control.disabled = false;
      control.closest('.zodiac-cart-item')?.removeAttribute('aria-busy');
      toast(error.message);
    }
  });
  doc.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = qs('[type="submit"]', form);
    button?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) { const error = await response.json(); throw new Error(error.description || 'Unable to add this object.'); }
      await refreshCart(true);
      toast('Object added to your cabinet.');
    } catch (error) { toast(error.message); }
    finally { button?.removeAttribute('aria-busy'); }
  });

  let searchTimer;
  qs('[data-predictive-search]')?.addEventListener('input', (event) => {
    clearTimeout(searchTimer);
    const term = event.target.value.trim();
    const results = qs('[data-predictive-results]');
    if (term.length < 2) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const endpoint = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(endpoint);
        const payload = await response.json();
        const products = payload.resources?.results?.products || [];
        results.innerHTML = products.length ? products.map((product) => `<a class="predictive-item" href="${product.url}">${product.image ? `<img src="${product.image}&width=140" width="70" height="70" alt="">` : '<span></span>'}<div><b>${escapeHTML(product.title)}</b><small>${escapeHTML(product.vendor || '')}</small></div><span>${product.price}</span></a>`).join('') : '<p>No objects found in this coordinate.</p>';
      } catch (_) { results.innerHTML = '<p>Search is temporarily outside the orbit.</p>'; }
    }, 220);
  });

  qs('[data-sort-select]')?.addEventListener('change', (event) => event.target.form.submit());
  qs('[data-filter-form]')?.addEventListener('change', (event) => { if (event.target.matches('input[type="checkbox"]')) event.currentTarget.submit(); });
  qsa('[data-copy-url]').forEach((button) => button.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(window.location.href); button.textContent = 'Copied'; }
    catch (_) { toast('Copy this page address from your browser.'); }
  }));

  qsa('[data-recommendations-url]').forEach(async (section) => {
    try {
      const response = await fetch(section.dataset.recommendationsUrl);
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = qs('[data-recommendations-url]', parsed);
      if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    } catch (_) { /* Recommendations remain intentionally empty. */ }
  });
})();
